import { ASE_INTERNAL_CHECK_TECHNICAL_BULLETIN_NUMBER } from "../../constants/websocketCommands";

export const ASE_INTERNAL_CLEAR_RELATED_TECHNICAL_BULLETINS = 'ASE_INTERNAL_CLEAR_RELATED_TECHNICAL_BULLETINS';

export const checkTechnicalBulletinNumber = technicalBulletinNumber => dispach =>
    dispach({
        type: ASE_INTERNAL_CHECK_TECHNICAL_BULLETIN_NUMBER,
        aseWebsocket: true,
        command: ASE_INTERNAL_CHECK_TECHNICAL_BULLETIN_NUMBER,
        payload: {
            technicalBulletinNumber
        },
    });

export const clearRelatedTechnicalBulletins = () => ({
    type: ASE_INTERNAL_CLEAR_RELATED_TECHNICAL_BULLETINS,
});

